import { EventEmitter, Injectable } from '@angular/core';

import { WebsocketService } from './websocket.service';

@Injectable({
	providedIn: 'root',
})
export class LockerService {
	constructor(private readonly websocket: WebsocketService) {
		this.websocket.action.subscribe((data) => {
			console.log(data);
		});
	}

	lock(module: string, id: string | number) {
		this.websocket.send({
			cmd: 'lock',
			module: module,
			id: id,
		});
	}

	unlock(module: string, id: string | number) {
		this.websocket.send({
			cmd: 'unlock',
			module: module,
			id: id,
		});
	}
}
